import * as stylex from '@stylexjs/stylex';
import '~styles/theme.stylex';
import { colors } from '~styles/theme.stylex';
const DESKTOP = '@media (min-width: 60rem)';
export const styles = {
  viewport: {
    display: "x78zum5",
    gap: "x8233eu",
    rowGap: null,
    columnGap: null,
    overflowX: "xw2csxc",
    scrollSnapType: "x1di6z1p",
    scrollSnapTypeX: null,
    scrollSnapTypeY: null,
    scrollPaddingInline: "xxu6dkj",
    scrollPaddingInlineStart: null,
    scrollPaddingInlineEnd: null,
    scrollPaddingLeft: null,
    scrollPaddingRight: null,
    marginTop: "x1mjqqkp",
    paddingBottom: "xes99ow",
    scrollbarWidth: "x1rohswg",
    "::-webkit-scrollbar_display": "xfk6m8",
    $$css: true
  },
  slide: {
    flex: "x19igk65 xvamgei",
    flexGrow: null,
    flexShrink: null,
    flexBasis: null,
    maxWidth: "x193iq5w",
    aspectRatio: "x2ebxmi xpx9vau",
    height: "xt7dq6l x1jthdc8",
    objectFit: "xl1xv1r",
    borderRadius: "x1j6x5gx",
    borderStartStartRadius: null,
    borderStartEndRadius: null,
    borderEndStartRadius: null,
    borderEndEndRadius: null,
    borderTopLeftRadius: null,
    borderTopRightRadius: null,
    borderBottomLeftRadius: null,
    borderBottomRightRadius: null,
    scrollSnapAlign: "x1hdbdi8 xq51190",
    backgroundColor: "x4aap8p",
    $$css: true
  },
  slideSingle: {
    flexBasis: "x1l7klhg",
    maxWidth: "x193iq5w",
    $$css: true
  }
};